import React, {useState, useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import BreadCrumbs from '../BreadCrumbs';
import { closeIcon, coursesIcon, filterIcon, homeIcon, leftArrowLong, searchIcon, noTestData } from "../../../constants/icons";
import { FormControl } from 'olive-react-myoneui';
import CourseItem from '../card/CourseItem';
import SampleImage from "../../../../assets/img/sample2.jpg";
import SampleImage2 from "../../../../assets/img/sample2.jpg";
import MykPagination from '../MykPagination';
import ArchiveFilter from './ArchiveFilter';
import ArchiveFilterMobile from './ArchiveFilterMobile';
import { getArchivedCourses } from '../../../../api/afterLogin/archives';
import { useSelector } from 'react-redux';
import { convertISOToReadable } from "../../../../helpers/datetime_helper";
import { courseMaterialUrl, filterUrl } from "../../../../helpers/url_helper";
import Error403 from '../../../../modules/Error403';
import { checkDisabledSp } from '../../../../helpers/permission_helper';
import NoItems from './NoItems';

const Archives = ({ className }) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const adminData  = useSelector((state) => state.admin);
  const configData = useSelector((state) => state.config);
  const paths = useSelector((state) => state.user.paths);
  const contentFilterData = useSelector((state) => state.contentFilter);
  const [data, setData] = useState('');
  const [keywords, setKeywords] = useState('');
  const [enrolledCourses, setEnrolledCourses] = useState([]);

  const [filterSlide, setFilterSlide] = useState();
  const [searchSlide, setSearchSlide] = useState();
  const [searchQuery, setSearchQuery] = useState('');
  const [scrollPosition, setScrollPosition] = useState(0);
  const [showEmptyItemBlock, setShowEmptyItemBlock] = useState(false);
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [abortController, setAbortController] = useState(null);

  /* ACCESS CHECK */
  const products  = adminData.products;
  const userSpEnabled = adminData?.user_sp_enabled;
  const [noAccess, setNoAccess] = useState(checkDisabledSp('mykademy', products, userSpEnabled));

  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleFilterSlide = () => {
    const body = document.body;

    if (filterSlide) {
      body.classList.remove('switched-filter-on');
      window.scrollTo(0, scrollPosition);
    } else {
      setScrollPosition(window.scrollY);
      body.classList.add('switched-filter-on');
      window.scrollTo(0, 0);
    }

    setFilterSlide(!filterSlide);
  }

  const handleCourseSearchSlide = () => {
    const body = document.body;

    if (searchSlide) {
      body.classList.remove('switched-search-on');
      window.scrollTo(0, scrollPosition);
    } else {
      setScrollPosition(window.scrollY);
      body.classList.add('switched-search-on');
      document.querySelector('.myk__stu-searchbar input[aria-label="Search"]').focus();
      window.scrollTo(0, 0);
    }

    setSearchSlide(!searchSlide);
  }

  const handleClearInput = () => {
    setSearchQuery('');
    document.querySelector('input[aria-label="Search"]').focus();
  };

  const coursePages = [
    { icon: homeIcon, label: "Home", url: "/student-dashboard/" },
    { icon: coursesIcon, label: "Archives" }
  ];

  const fetchContents = async (params) => {
    const {selectedFilters, selectedRadio, formatedValidityDate, selectedValidityDays, offset } = contentFilterData; 

    const postParams = {};
    //Enrollment Status Filter
    if(selectedFilters?.enrollmentStatus?.length > 0) {
      const enrollmentStatus = selectedFilters.enrollmentStatus;
      postParams.enroll_status = enrollmentStatus;
    }

    //Validity Status Filter
    if(selectedRadio != '') {
      const validity_type = selectedRadio;
      postParams.validity_type = validity_type;

      if(selectedRadio === "validity-lifetime") {
        postParams.validity = "lifetime";
      } else if( selectedRadio === "validity-days") {
        postParams.validity = selectedValidityDays.value;
      } else {
        postParams.validity = formatedValidityDate.split(" ")[0];
      }
    }

    //Course Type Filter
    if(selectedFilters?.courseType?.length > 0) {
      const courseType = selectedFilters.courseType;
      postParams.content_type = courseType;
    }

    //Category Filter
    if(selectedFilters?.category?.length > 0) {
      const category = selectedFilters.category;
      postParams.categories = category;
    }

    params.page_offset = offset;

    const allEnrolledCourses = await getArchivedCourses(configData.access_token, params, postParams);
    return allEnrolledCourses;
  };

  const handleKeywords = (e) => {
    setKeywords(e.target.value);
  }
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(keywords);
    }, 500);
    return () => clearTimeout(handler);
  }, [keywords]);

  useEffect(() => {
    if (abortController) {
      abortController.abort();
    }
    const newAbortController = new AbortController();
    setAbortController(newAbortController);
    const signal = newAbortController.signal;

    if (signal && !signal.aborted) {
      const loadData = async () => {
        const data = await fetchContents({page_limit: 15, search: keywords});
        if (data) {
          setData(data);
          setEnrolledCourses(data.data);
        }
      }
      loadData();
    }
  }, [contentFilterData, debouncedSearch]);

  const archiveData = enrolledCourses && enrolledCourses.map((value) => {
    return {
      className: "",
      archiveId: value.id,
      courseId: value.csa_cs_course_id,
      courseImage: value.csa_cb_image ? paths.course_path + value.csa_cb_image : '',
      courseType: value?.item_type,
      courseTitle: value?.csa_cs_course_tittle,
      courseDeadline: `Archived on ${value.created_date ? convertISOToReadable(value.created_date, 'short', false) : ''}`,
      courseLectureCount: `${value?.lecture_count ?? 0} Lecture${value?.lecture_count > 1 ? "s":""}`,
      courseTypeLearning: value?.category,
      courseStartButton: "Start Course",
      courseDetailLink: `/student-dashboard/archives/detail/${value?.id}` ?? '',
      courseButtonLabel: "Start Course",
      courseProgressPercentage: `${value?.csa_cs_percentage}`,
      courseStatus: value?.csa_cs_percentage === 0 ? 'notStarted' : (value?.csa_cs_percentage > 0 && value?.csa_cs_percentage < 100) ? 'inProgress' : 'completed',
      isCertificateOnlyArchived: value?.csa_is_certificate_only_archived ?? 0
  }
});

  return (
    <>
    {noAccess ? <Error403 /> : (
    <>
    <BreadCrumbs pages={coursePages} />
    <div className={`${className || ""} myk__stu-courses-wrapper`}>
      <Row>
        <Col md={{ span:12, order: 0 }} lg={{ span:12, order: 0 }} xl={{ span:9, order: 0 }} className="">
          <div className="myk_stu-page-header">
            <h2>Archives</h2>
            <div className="myk__stu-searchbar">
                <span className="icon">{searchIcon}</span>
                <FormControl 
                  placeholder="Search course by keywords" 
                  aria-label="Search" 
                  onChange={handleKeywords} 
                />
                <span className="icon-go_back" onClick={handleCourseSearchSlide}>{leftArrowLong}</span>
                <span className="icon-clear" onClick={handleClearInput}>{closeIcon}</span>
            </div>
            <div className="myk__stu-search_filter-mobile">
              <div className="myk__stu-search-wrapper">
                <span className="icon" role="button" onClick={handleCourseSearchSlide}>{searchIcon}</span>
              </div>
              <div className="myk__stu-filter-mobile" role="button" onClick={handleFilterSlide}>
                {filterIcon}
              </div>
            </div>
          </div>
          {screenWidth >= 768 && screenWidth < 1200 && (
            <ArchiveFilterMobile className="mb-4" />
          )}
          <Row>
            <Col>
              {enrolledCourses && enrolledCourses.length > 0 ? 
              (<div className="myk__stu-courses-list">
                {archiveData.map((archive, index) => (
                  <CourseItem key={index} {...archive} />
                ))}
              </div>) : 
              (<div className="myk__stu-courseslist-empty p-0 text-center empty-block-wrapper d-flex align-items-center justify-content-center">
                <NoItems
                  icon={noTestData}
                  title="No Archived Courses Found!"
                  description="There aren’t any courses archived!"
                />
              </div>
              )
              }
            </Col>
          </Row>
          <Row>
            <Col>
              {data && <MykPagination className="mt-4" data={data}/>}
            </Col>
          </Row>
        </Col>
        {(screenWidth <= 767 || screenWidth >= 1200) && (
        <Col md={{ span:12, order: 0 }} lg={{ span:12, order: 0 }} xl={{ span:3, order: 0 }} className="">
          <ArchiveFilter onClickFilterSlide={handleFilterSlide}/>
        </Col>
        )}
      </Row>
    </div>
    </>
    )}
    </>
  );
}

export default Archives;
